// ========================================
// Email Settings View - administration or individually delegated access
// ========================================

// Default of the «Datos de acceso del alumno» template; same text as server/security/student-import.js.
const STUDENT_ACCESS_BODY = `<div style="max-width:600px;margin:0 auto;font-family:'Source Sans 3',Arial,sans-serif;color:#1e293b;">
    <div style="background:linear-gradient(135deg,#0F766E 0%,#115E59 100%);color:#fff;padding:2.5rem 2rem;text-align:center;border-radius:12px 12px 0 0;">
        <h1 style="margin:0;font-size:1.75rem;font-weight:700;">Tus datos de acceso</h1>
    </div>
    <div style="background:#fff;border:1px solid #e2e8f0;border-top:none;padding:2.5rem 2rem;">
        <p style="font-size:1.125rem;font-weight:600;color:#0f172a;">Hola, {{nombre}}:</p>
        <p>Ya tienes tu cuenta en <strong>SICAF</strong>, la plataforma de la {{escuela}}. Estos son tus datos para entrar:</p>
        <div style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:8px;padding:1.5rem;margin:2rem 0;">
            <div style="margin-bottom:0.75rem;"><strong style="color:#475569;">Usuario:</strong> <span style="font-family:monospace;font-weight:700;color:#0f766e;">{{usuario}}</span></div>
            <div><strong style="color:#475569;">Contraseña:</strong> <span style="font-family:monospace;font-weight:700;color:#0f766e;">{{contrasena}}</span></div>
        </div>
        <p>También puedes entrar con tu correo electrónico en lugar del usuario.</p>
        <div style="background:#fffbeb;border-left:4px solid #f59e0b;color:#78350f;padding:1rem;border-radius:4px;font-size:0.9rem;">
            <strong>Importante:</strong> la contraseña es temporal. Al entrar por primera vez tendrás que elegir una nueva.
        </div>
        <div style="text-align:center;margin:2rem 0 1rem;">
            <a href="{{enlace}}" style="display:inline-block;background:#0f766e;color:#fff;text-decoration:none;padding:0.75rem 2rem;border-radius:99px;font-weight:600;">Entrar en SICAF</a>
        </div>
    </div>
    <div style="background:#f8fafc;padding:1.5rem 2rem;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;text-align:center;font-size:0.75rem;color:#64748b;">Secretaría de {{escuelaSiglas}}</div>
</div>`;

const EmailSettingsView = {
    config: null,
    txEditorMode: 'wysiwyg', // 'wysiwyg' | 'html' — editor de la pestaña "Correos"

    // Plantillas de correo TRANSACCIONALES (las que dispara el propio flujo de
    // matrícula, no las campañas de marketing de Leads — esas siguen en
    // #email-templates, `EmailTemplatesView`) — mismo almacén de BD
    // (GlobalSettings.emailTemplates, vía GET/PUT /api/settings/email-templates,
    // por eso no hizo falta tocar el backend de plantillas, ya era genérico por
    // `type`). El `defaultSubject`/`defaultBody` de cada una es una copia fiel
    // del HTML de fallback que ya lleva cada correo en server.js — así, la
    // primera vez que se abre el editor, se ve exactamente lo que se está
    // mandando de verdad, no una plantilla en blanco.
    TX_TEMPLATES: [
        {
            type: 'draft_token',
            label: 'Borrador de matrícula (token para continuar)',
            help: 'Se manda al guardar el PRIMER borrador en el formulario de inscripción (/inscribete) (antes de enviar la solicitud completa).',
            vars: ['nombre', 'token', 'enlace'],
            defaultSubject: '{{escuelaSiglas}} - Tu borrador de matrícula (token para continuar)',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Source Sans 3',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0F766E 0%,#115E59 100%);color:#fff;padding:2.5rem 2rem;text-align:center;border-radius:12px 12px 0 0;">
        <h1 style="margin:0;font-size:1.75rem;font-weight:700;">Borrador Guardado</h1>
    </div>
    <div style="background:#fff;border:1px solid #e2e8f0;border-top:none;padding:2.5rem 2rem;">
        <p style="font-size:1.125rem;font-weight:600;color:#0f172a;">Hola, {{nombre}}:</p>
        <p>Has empezado tu solicitud de matrícula en la {{escuela}} y hemos guardado tus datos como borrador. Todavía no la has enviado — puedes seguir rellenándola cuando quieras con tu token personal:</p>
        <div style="background:#1e293b;color:#38bdf8;padding:0.9rem;border-radius:8px;font-weight:700;margin:1.25rem 0;font-size:1.15rem;font-family:monospace;letter-spacing:1px;text-align:center;">{{token}}</div>
        <div style="text-align:center;margin:2rem 0 1rem;">
            <a href="{{enlace}}" style="display:inline-block;background:#0f766e;color:#fff;text-decoration:none;padding:0.75rem 2rem;border-radius:99px;font-weight:600;">Continuar mi solicitud</a>
        </div>
        <p style="font-size:0.8rem;color:#64748b;word-break:break-all;text-align:center;">O copia y pega este enlace en tu navegador:<br>{{enlace}}</p>
        <div style="background:#fffbeb;border-left:4px solid #f59e0b;color:#78350f;padding:1rem;border-radius:4px;font-size:0.9rem;margin-top:1.5rem;">
            <strong>Nota importante:</strong> este enlace es personal e intransferible — no lo compartas, es la forma en la que el sistema identifica tu solicitud. Guarda este correo, es la única forma de recuperar tu borrador si pierdes el enlace.
        </div>
    </div>
    <div style="background:#f8fafc;padding:1.5rem 2rem;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;text-align:center;font-size:0.75rem;color:#64748b;">Mensaje automático generado por la Secretaría de {{escuelaSiglas}}. Por favor, no respondas a este correo.</div>
</div>`
        },
        {
            type: 'enrollment_confirmation',
            label: 'Confirmación de solicitud enviada',
            help: 'Se manda cuando el aspirante pulsa "Enviar Solicitud" (formulario completo, sin pasar antes por un borrador o después de él).',
            vars: ['nombre', 'enlace'],
            defaultSubject: '{{escuelaSiglas}} - Confirmación de tu solicitud de matrícula',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Source Sans 3',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0F766E 0%,#115E59 100%);color:#fff;padding:2.5rem 2rem;text-align:center;border-radius:12px 12px 0 0;">
        <h1 style="margin:0;font-size:1.75rem;font-weight:700;">¡Solicitud Recibida!</h1>
    </div>
    <div style="background:#fff;border:1px solid #e2e8f0;border-top:none;padding:2.5rem 2rem;">
        <p style="font-size:1.125rem;font-weight:600;color:#0f172a;">Hola, {{nombre}}:</p>
        <p>Hemos recibido correctamente tu solicitud de matrícula en la {{escuela}}. Nuestro equipo la revisará en breve.</p>
        <p><strong>Todavía tienes un paso pendiente:</strong> subir la documentación de pago (justificante, DNI para domiciliación, etc.). Puedes hacerlo cuando quieras entrando de nuevo con el siguiente enlace:</p>
        <div style="text-align:center;margin:2rem 0 1rem;">
            <a href="{{enlace}}" style="display:inline-block;background:#0f766e;color:#fff;text-decoration:none;padding:0.75rem 2rem;border-radius:99px;font-weight:600;">Continuar con mi solicitud</a>
        </div>
        <p style="font-size:0.8rem;color:#64748b;word-break:break-all;text-align:center;">O copia y pega este enlace en tu navegador:<br>{{enlace}}</p>
        <div style="background:#fffbeb;border-left:4px solid #f59e0b;color:#78350f;padding:1rem;border-radius:4px;font-size:0.9rem;margin-top:1.5rem;">
            <strong>Nota importante:</strong> este enlace es personal e intransferible — no lo compartas, es la forma en la que el sistema identifica tu solicitud.
        </div>
    </div>
    <div style="background:#f8fafc;padding:1.5rem 2rem;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;text-align:center;font-size:0.75rem;color:#64748b;">Mensaje automático generado por la Secretaría de {{escuelaSiglas}}. Por favor, no respondas a este correo.</div>
</div>`
        },
        {
            type: 'payment_section',
            label: 'Sección de pago disponible',
            help: 'Se manda al alumno cuando su Enrollment pasa a estado "payment" (p.ej. "Doc pago" en Prematrícula, o entrevista superada en una solicitud online).',
            vars: ['nombre', 'enlace'],
            defaultSubject: '{{escuelaSiglas}} - Ya puedes completar el pago de tu matrícula',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Source Sans 3',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0F766E 0%,#115E59 100%);color:#fff;padding:2.5rem 2rem;text-align:center;border-radius:12px 12px 0 0;">
        <h1 style="margin:0;font-size:1.75rem;font-weight:700;">¡Sección de Pago Disponible!</h1>
    </div>
    <div style="background:#fff;border:1px solid #e2e8f0;border-top:none;padding:2.5rem 2rem;">
        <p style="font-size:1.125rem;font-weight:600;color:#0f172a;">Hola, {{nombre}}:</p>
        <p>¡Enhorabuena! Has superado la entrevista y tu proceso de admisión en la {{escuela}} avanza a la siguiente fase. Ya tienes disponible la sección de pago en tu formulario de matrícula, donde podrás subir el justificante y la documentación necesaria.</p>
        <div style="text-align:center;margin:2rem 0 1rem;">
            <a href="{{enlace}}" style="display:inline-block;background:#0f766e;color:#fff;text-decoration:none;padding:0.75rem 2rem;border-radius:99px;font-weight:600;">Completar el pago</a>
        </div>
        <p style="font-size:0.8rem;color:#64748b;word-break:break-all;text-align:center;">O copia y pega este enlace en tu navegador:<br>{{enlace}}</p>
        <div style="background:#fffbeb;border-left:4px solid #f59e0b;color:#78350f;padding:1rem;border-radius:4px;font-size:0.9rem;margin-top:1.5rem;">
            <strong>Nota importante:</strong> este enlace es personal e intransferible — no lo compartas, es la forma en la que el sistema identifica tu solicitud.
        </div>
    </div>
    <div style="background:#f8fafc;padding:1.5rem 2rem;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;text-align:center;font-size:0.75rem;color:#64748b;">Mensaje automático generado por la Secretaría de {{escuelaSiglas}}. Por favor, no respondas a este correo.</div>
</div>`
        },
        {
            type: 'payment_docs_staff',
            label: 'Aviso interno: documentación de pago recibida',
            help: 'Va al staff (destinatario "Notificación de Documentación de Pago" de esta misma página), no al alumno — cuando termina de subir/enviar su justificante o documentación de financiación.',
            vars: ['nombre', 'apellidos', 'dni', 'telefono', 'email', 'formacion', 'tipoPago', 'documentosAdjuntos'],
            defaultSubject: 'Documentación de Pago Recibida - {{nombre}} {{apellidos}}',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0f172a 0%,#1e293b 100%);color:#fff;padding:2.2rem 1.5rem;text-align:center;border-bottom:4px solid #10b981;border-radius:16px 16px 0 0;">
        <h1 style="margin:0;font-size:1.35rem;font-weight:700;text-transform:uppercase;letter-spacing:1px;">Documentación de Pago Recibida</h1>
    </div>
    <div style="background:#fff;border:1px solid #e5e7eb;border-top:none;padding:1.8rem 1.5rem;">
        <p style="color:#4b5563;">Un alumno ha terminado de subir su documentación de pago desde su enlace de matrícula. Puede revisarla desde Alumnado / Pre-Matrícula.</p>
        <div style="background:#ecfdf5;border-left:4px solid #10b981;border-radius:0 12px 12px 0;padding:1.1rem;margin-bottom:1.1rem;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#059669;font-weight:700;margin-bottom:0.4rem;">Forma de Pago</div>
            <div style="font-weight:700;color:#059669;">{{tipoPago}}</div>
        </div>
        <div style="background:#f9fafb;border-radius:12px;padding:1.1rem;margin-bottom:1.1rem;border:1px solid #f3f4f6;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#6b7280;font-weight:700;margin-bottom:0.6rem;">Datos del Alumno</div>
            <div><strong>Nombre:</strong> {{nombre}} {{apellidos}}</div>
            <div><strong>DNI:</strong> {{dni}}</div>
            <div><strong>Teléfono:</strong> {{telefono}}</div>
            <div><strong>Email:</strong> {{email}}</div>
        </div>
        <div style="background:#f9fafb;border-radius:12px;padding:1.1rem;margin-bottom:1.1rem;border:1px solid #f3f4f6;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#6b7280;font-weight:700;margin-bottom:0.6rem;">Formación Solicitada</div>
            <div>{{formacion}}</div>
        </div>
        <div style="background:#f9fafb;border-radius:12px;padding:1.1rem;border:1px solid #f3f4f6;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#6b7280;font-weight:700;margin-bottom:0.6rem;">Documentos Adjuntos en este Correo</div>
            <ul style="margin:0;padding-left:18px;">{{documentosAdjuntos}}</ul>
        </div>
    </div>
    <div style="background:#f9fafb;padding:1.4rem;border:1px solid #e5e7eb;border-top:none;border-radius:0 0 16px 16px;text-align:center;font-size:0.7rem;color:#9ca3af;">Mensaje automático generado por el Sistema SICAF. Por favor, no respondas a este correo.</div>
</div>`
        },
        {
            type: 'interview_staff',
            label: 'Aviso interno: hay que programar entrevista',
            help: 'Va al staff (destinatario "Notificación de Entrevistas" de esta misma página), no al alumno — en el momento en que se marca al candidato para entrevista personal, ANTES de que se le asigne día y hora (esa confirmación va al alumno con la plantilla "Citación a entrevista").',
            vars: ['nombre', 'apellidos', 'dni', 'telefono', 'email', 'formacion', 'tipoFormacion'],
            defaultSubject: 'Hay que programar entrevista - {{nombre}} {{apellidos}}',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0f172a 0%,#1e293b 100%);color:#fff;padding:2.2rem 1.5rem;text-align:center;border-bottom:4px solid #3b82f6;border-radius:16px 16px 0 0;">
        <h1 style="margin:0;font-size:1.35rem;font-weight:700;text-transform:uppercase;letter-spacing:1px;">Entrevista Pendiente de Programar</h1>
    </div>
    <div style="background:#fff;border:1px solid #e5e7eb;border-top:none;padding:1.8rem 1.5rem;">
        <p style="color:#4b5563;">Hola, la siguiente solicitud de matrícula necesita una entrevista personal. Contacta con el candidato para acordar día y hora:</p>
        <div style="background:#f9fafb;border-radius:12px;padding:1.1rem;margin-bottom:1.1rem;border:1px solid #f3f4f6;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#6b7280;font-weight:700;margin-bottom:0.6rem;">Datos del Alumno</div>
            <div><strong>Nombre:</strong> {{nombre}} {{apellidos}}</div>
            <div><strong>DNI:</strong> {{dni}}</div>
            <div><strong>Teléfono:</strong> {{telefono}}</div>
            <div><strong>Email:</strong> {{email}}</div>
        </div>
        <div style="background:#f9fafb;border-radius:12px;padding:1.1rem;border:1px solid #f3f4f6;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#6b7280;font-weight:700;margin-bottom:0.6rem;">Formación Solicitada</div>
            <div><strong>Curso:</strong> {{formacion}}</div>
            <div><strong>Tipo:</strong> {{tipoFormacion}}</div>
        </div>
        <div style="text-align:center;margin-top:1.75rem;">
            <a href="http://localhost:8000/#entrevistas" style="display:inline-block;background:#0f172a;color:#fff;text-decoration:none;padding:0.75rem 2rem;border-radius:99px;font-weight:600;font-size:0.9rem;">Ir a Planificación de Entrevistas</a>
        </div>
    </div>
    <div style="background:#f9fafb;padding:1.4rem;border:1px solid #e5e7eb;border-top:none;border-radius:0 0 16px 16px;text-align:center;font-size:0.7rem;color:#9ca3af;">Mensaje automático generado por el Sistema SICAF. Por favor, no respondas a este correo.</div>
</div>`
        },
        {
            type: 'interview_student',
            label: 'Citación a entrevista (para el alumno)',
            help: 'Se envía automáticamente al alumno cuando se le asigna día y hora de entrevista desde Planificación de Entrevistas o Pre-Matrícula.',
            vars: ['nombre', 'apellidos', 'fecha', 'hora', 'curso'],
            defaultSubject: '{{escuelaSiglas}} - Convocatoria de Entrevista de Admisión',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Source Sans 3',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0F766E 0%,#115E59 100%);color:#fff;padding:2.5rem 2rem;text-align:center;border-radius:12px 12px 0 0;">
        <h1 style="margin:0;font-size:1.75rem;font-weight:700;">Entrevista Personal de Admisión</h1>
    </div>
    <div style="background:#fff;border:1px solid #e2e8f0;border-top:none;padding:2.5rem 2rem;">
        <p style="font-size:1.125rem;font-weight:600;color:#0f172a;">Hola, {{nombre}}:</p>
        <p>Te convocamos a la entrevista personal de admisión para la formación <strong>{{curso}}</strong> en la {{escuela}}.</p>
        
        <div style="background:#f0fdf4;border:1px solid #bbf7d0;border-left:4px solid #0f766e;border-radius:8px;padding:1.25rem;margin:1.75rem 0;">
            <div style="font-size:0.75rem;text-transform:uppercase;color:#0f766e;font-weight:700;letter-spacing:0.05em;margin-bottom:0.6rem;">Detalles de la Cita</div>
            <div style="font-size:1rem;color:#0f172a;margin-bottom:0.4rem;"><strong>Fecha:</strong> {{fecha}}</div>
            <div style="font-size:1rem;color:#0f172a;margin-bottom:0.4rem;"><strong>Hora:</strong> {{hora}}</div>
            <div style="font-size:1rem;color:#0f172a;"><strong>Curso:</strong> {{curso}}</div>
        </div>

        <p>Esta entrevista nos permitirá conocerte mejor, valorar tus inquietudes cinematográficas y explicarte en detalle el funcionamiento del programa académico.</p>
        
        <div style="background:#fffbeb;border-left:4px solid #f59e0b;color:#78350f;padding:1rem;border-radius:4px;font-size:0.88rem;margin-top:1.5rem;">
            <strong>Importante:</strong> Si necesitas modificar el día u hora de tu cita por motivos de fuerza mayor, por favor ponte en contacto con nosotros respondiendo a este correo o llamando a Secretaría.
        </div>
    </div>
    <div style="background:#f8fafc;padding:1.5rem 2rem;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;text-align:center;font-size:0.75rem;color:#64748b;">
        {{escuela}} · Secretaría Académica
    </div>
</div>`
        },
        {
            type: 'welcome_credentials',
            label: 'Bienvenida y credenciales de acceso',
            help: 'Se manda al crear la cuenta de acceso al portal del alumno (al marcar "Pagado", o desde el botón "Crear acceso al portal" en Prematrícula).',
            vars: ['nombre', 'usuario', 'contrasena'],
            defaultSubject: 'Bienvenido a {{escuelaSiglas}} - Tu cuenta de acceso',
            defaultBody: `<div style="max-width:600px;margin:0 auto;font-family:'Source Sans 3',Arial,sans-serif;">
    <div style="background:linear-gradient(135deg,#0F766E 0%,#115E59 100%);color:#fff;padding:2.5rem 2rem;text-align:center;border-radius:12px 12px 0 0;">
        <h1 style="margin:0;font-size:1.75rem;font-weight:700;">¡Matrícula Confirmada!</h1>
    </div>
    <div style="background:#fff;border:1px solid #e2e8f0;border-top:none;padding:2.5rem 2rem;">
        <p style="font-size:1.125rem;font-weight:600;color:#0f172a;">Hola, {{nombre}}:</p>
        <p>Hemos registrado el pago de tu matrícula en la {{escuela}}. ¡Bienvenido/a!</p>
        <p>Hemos creado tu cuenta de acceso al portal de alumnos <strong>SICAF</strong>. A continuación se muestran tus credenciales de acceso:</p>
        <div style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:8px;padding:1.5rem;margin:2rem 0;">
            <div style="margin-bottom:0.75rem;"><strong style="color:#475569;">Usuario:</strong> <span style="font-family:monospace;font-weight:700;color:#0f766e;">{{usuario}}</span></div>
            <div><strong style="color:#475569;">Contraseña:</strong> <span style="font-family:monospace;font-weight:700;color:#0f766e;">{{contrasena}}</span></div>
        </div>
        <div style="background:#fffbeb;border-left:4px solid #f59e0b;color:#78350f;padding:1rem;border-radius:4px;font-size:0.9rem;">
            <strong>Nota importante:</strong> Por motivos de seguridad, la contraseña proporcionada es temporal. Al iniciar sesión por primera vez, el sistema te solicitará que la cambies por una de tu elección.
        </div>
        <div style="text-align:center;margin:2rem 0 1rem;">
            <a href="http://localhost:8000" style="display:inline-block;background:#0f766e;color:#fff;text-decoration:none;padding:0.75rem 2rem;border-radius:99px;font-weight:600;">Acceder al Portal</a>
        </div>
    </div>
    <div style="background:#f8fafc;padding:1.5rem 2rem;border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;text-align:center;font-size:0.75rem;color:#64748b;">Mensaje automático generado por la Secretaría de {{escuelaSiglas}}. Por favor, no respondas a este correo.</div>
</div>`
        },
        {
            type: 'student_access',
            label: 'Datos de acceso del alumno',
            help: 'Se manda solo cuando administración pulsa «Enviar acceso» en Alumnado. Cada envío lleva una contraseña nueva y la anterior deja de valer.',
            vars: ['nombre', 'usuario', 'contrasena', 'enlace'],
            defaultSubject: 'Tus datos de acceso a {{escuelaSiglas}}',
            defaultBody: STUDENT_ACCESS_BODY
        },
        {
            type: 'staff_access',
            label: 'Datos de acceso del profesor',
            help: 'Se manda cuando administración da acceso a un profesor o pulsa «Enviar acceso» en Personal. Cada envío lleva una contraseña nueva y la anterior deja de valer.',
            vars: ['nombre', 'usuario', 'contrasena', 'enlace'],
            defaultSubject: 'Tus datos de acceso a {{escuelaSiglas}}',
            defaultBody: STUDENT_ACCESS_BODY
        },
        {
            type: 'professor_advisory',
            label: 'Alta de profesor/a para la asesoría',
            defaultSubject: 'Alta profesor/a: {{nombre}} {{apellidos}}',
            vars: ['nombre', 'apellidos', 'dni', 'nss', 'direccion', 'fechaAlta', 'fechaBaja', 'jornada', 'salario', 'irpf'],
            defaultBody: `<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #e2e8f0; border-radius: 8px; color: #1e293b;">
    <div style="background-color: #f8fafc; padding: 15px; border-radius: 6px; margin-bottom: 20px; border-left: 4px solid #0891b2;">
        <h2 style="margin: 0; color: #0891b2; font-size: 1.25rem;">Gestión de Alta de Profesorado</h2>
    </div>
    <p style="font-size: 1rem; line-height: 1.5;">Hola,</p>
    <p style="font-size: 1rem; line-height: 1.5;">Hay que dar de alta al profesor/a:</p>
    <div style="background-color: #ffffff; border: 1px solid #e2e8f0; padding: 20px; border-radius: 6px; margin: 20px 0;">
        <table style="width: 100%; border-collapse: collapse;">
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem; width: 160px;">Nombre completo:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">{{nombre}} {{apellidos}}</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem;">DNI:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">{{dni}}</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem;">Nº Seguridad Social:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">{{nss}}</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem;">Dirección:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">{{direccion}}</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem;">Periodo de alta:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">Del {{fechaAlta}} al {{fechaBaja}}</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem;">Jornada:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">{{jornada}} horas/semana</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem;">IRPF:</td><td style="padding: 8px 0; font-weight: 600; font-size: 0.875rem">{{irpf}}</td></tr>
            <tr><td style="padding: 8px 0; color: #64748b; font-size: 0.875rem; border-top: 1px solid #e2e8f0; padding-top: 16px;">Salario:</td><td style="padding: 8px 0; font-weight: 600; font-size: 1.125rem; color: #0891b2; border-top: 1px solid #e2e8f0; padding-top: 16px;">{{salario}}/mes brutos</td></tr>
        </table>
    </div>
    <p style="font-size: 1rem; line-height: 1.5; margin-top: 30px;">Un saludo.</p>
    <hr style="border: 0; border-top: 1px solid #e2e8f0; margin: 30px 0;">
    <p style="font-size: 0.75rem; color: #94a3b8; text-align: center;">Mensaje automático generado por el sistema de gestión de {{escuelaSiglas}}.</p>
</div>`
        }
    ],

    // ─── Design A2 (Oct 2026): a menu on the left (sending, notices, the 10 automatic e-mails),
    // the section on the right and one bar at the bottom for what is unsaved.
    // Who sends each automatic e-mail and to whom; the variables it cannot go without.
    TX_INFO: {
        draft_token: { from: 'Admisiones', to: 'Aspirante', required: ['token', 'enlace'] },
        enrollment_confirmation: { from: 'Admisiones', to: 'Aspirante', required: [] },
        payment_section: { from: 'Administración', to: 'Alumno', required: ['enlace'] },
        payment_docs_staff: { from: 'Administración', to: 'Secretaría (aviso interno)', required: [] },
        interview_staff: { from: 'Admisiones', to: 'Admisiones (aviso interno)', required: [] },
        interview_student: { from: 'Admisiones', to: 'Aspirante', required: ['fecha', 'hora'] },
        welcome_credentials: { from: 'Administración', to: 'Alumno', required: ['usuario', 'contrasena'] },
        student_access: { from: 'Administración', to: 'Alumno', required: ['usuario', 'contrasena'] },
        staff_access: { from: 'Administración', to: 'Profesor/a', required: ['usuario', 'contrasena'] },
        professor_advisory: { from: 'Administración', to: 'Asesoría', required: ['nombre', 'apellidos', 'dni'] }
    },
    VAR_LABELS: { contrasena: 'la contraseña', usuario: 'el usuario', token: 'el token', enlace: 'el enlace', fecha: 'la fecha', hora: 'la hora', nombre: 'el nombre', apellidos: 'los apellidos', dni: 'el DNI' },
    SAMPLE: { nombre: 'Ane', apellidos: 'Ejemplo Ejemplo', usuario: 'ane.ejemplo', contrasena: 'Ejemplo-2026', token: 'EJ3MPL0', enlace: 'https://ejemplo.es', dni: '00000000T', nss: '000000000000',
        telefono: '600 000 000', email: 'ane@ejemplo.es', formacion: 'Formación de ejemplo', tipoFormacion: 'Ciclo', tipoPago: 'Transferencia', documentosAdjuntos: 'Justificante.pdf',
        fecha: '12 de noviembre', hora: '10:30', curso: '2026/2027', direccion: 'Calle Ejemplo 1', fechaAlta: '01/11/2026', fechaBaja: '30/06/2027', jornada: '10', salario: '1.000,00 €', irpf: '15 %' },
    section: 'server',
    _edited: {},
    _txType: null,
    _txLoaded: null,     // { subject, body } as loaded or saved
    _device: 'desktop',

    render() {
        return `
            <div class="dnr-proposal esa" style="padding-top: 1rem;">
                <nav class="esa-nav" aria-label="Secciones de correo">
                    <div class="dnr-hero-eyebrow esa-eyebrow">Ajustes</div>
                    <h1 class="esa-title">Correo</h1>
                    <div class="esa-menu" id="esa-menu"></div>
                </nav>
                <div class="esa-main">
                    <div id="email-settings-form-container">
                        <p class="esa-muted"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Cargando configuración…</p>
                    </div>
                    <section class="esa-card" id="es-overview" hidden></section>
                    <section class="esa-card" id="es-panel-correos" hidden></section>
                    <div class="esa-bar" id="esa-bar"></div>
                </div>
            </div>`;
    },

    async init() {
        try {
            await this.loadConfig();
            this.renderForm();
        } catch (error) {
            console.error('Error al inicializar EmailSettingsView:', error);
            const container = document.getElementById('email-settings-form-container');
            if (container) SafeHTML.set(container, '<div class="esa-card esa-error" role="alert"><b>Error de carga</b><p>No se pudo conectar con el servidor para obtener la configuración. Vuelve a intentarlo.</p></div>');
        }
        if (AuthManager.isAdmin()) {
            try {
                const res = await fetch('/api/settings/email-templates', { headers: { 'X-SICAF-CSRF': AuthManager.getCsrfToken() } });
                const data = await res.json().catch(() => null);
                if (res.ok && data?.success) this._edited = data.edited || {};
            } catch { /* the marks just stay empty */ }
        }
        this.showSection(this.section);
    },

    _ago(iso) { return iso ? new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }) : ''; },

    renderMenu() {
        const menu = document.getElementById('esa-menu');
        if (!menu) return;
        const c = this.config || {};
        const admin = AuthManager.isAdmin();
        const dest = ['advisoryRecipient', 'interviewRecipient', 'paymentDocsRecipient', 'replyToAddress'].filter(k => c[k]).length;
        const item = (id, label, mark, warn = false) => `<button type="button" class="esa-item ${this.section === id ? 'is-active' : ''}" aria-current="${this.section === id ? 'page' : 'false'}"
            ${UIEvents.attr("click", function(event,captured){EmailSettingsView.showSection(String(captured[0]));}, [id])}><span class="esa-item-label">${Utils.sanitizeHTML(label)}</span><span class="esa-mark ${warn ? 'is-warn' : ''}">${Utils.sanitizeHTML(mark)}</span></button>`;
        const txMark = t => this._txType === t.type && this._missingVars().length ? '⚠' : this._edited[t.type] !== undefined ? 'editado' : '';
        SafeHTML.set(menu, `
            <span class="esa-group">Envío</span>
            ${item('server', 'Servidor de salida', c.smtpHost && c.smtpPassSet ? '✓' : 'falta', !(c.smtpHost && c.smtpPassSet))}
            ${this.GROUPS.map(g => item('acc-' + g.key, `Cuenta de ${g.label}`, c.groups?.[g.key]?.smtpUser ? '✓' : 'general', !c.groups?.[g.key]?.smtpUser)).join('')}
            <span class="esa-group">Avisos</span>
            ${item('dest', 'Destinatarios de avisos', String(dest))}
            ${admin ? `<span class="esa-group">Correos automáticos</span>
            ${item('all', 'Todos (portada)', String(this.TX_TEMPLATES.length))}
            ${this.TX_TEMPLATES.map(t => item('tx:' + t.type, t.label, txMark(t), txMark(t) === '⚠')).join('')}` : ''}`);
    },

    // Shows one section. Leaving an e-mail with unsaved changes asks first.
    async showSection(id) {
        if (this.section !== id && this.section.startsWith('tx:') && this._txDirty()) {
            const result = await SafeHTML.fire({ title: 'Hay cambios sin guardar', text: `Si sales de «${this.getCurrentTxTemplateMeta()?.label || 'este correo'}» se perderán.`, icon: 'warning',
                showCancelButton: true, confirmButtonText: 'Salir sin guardar', cancelButtonText: 'Seguir editando', confirmButtonColor: '#8E2A21', reverseButtons: true });
            if (!result.isConfirmed) return;
        }
        this.section = id;
        const form = document.getElementById('email-settings-form-container');
        const overview = document.getElementById('es-overview');
        const editor = document.getElementById('es-panel-correos');
        const isTx = id.startsWith('tx:');
        if (form) form.hidden = id === 'all' || isTx;
        document.querySelectorAll('[data-es-section]').forEach(el => { el.hidden = el.dataset.esSection !== id; });
        if (overview) { overview.hidden = id !== 'all'; if (id === 'all') this.renderOverview(); }
        if (editor) {
            editor.hidden = !isTx;
            if (isTx) {
                if (!editor.dataset.loaded) { editor.dataset.loaded = '1'; this.renderTemplatesPanel(); }
                this.loadTxTemplate(id.slice(3));
            }
        }
        this.renderMenu();
        this.renderBar();
    },

    renderOverview() {
        const box = document.getElementById('es-overview');
        if (!box) return;
        SafeHTML.set(box, `
            <div class="esa-card-head"><h2>Correos automáticos</h2><p>Lo que SICAF manda solo: cuándo, desde qué cuenta y a quién. Pulsa uno para editarlo.</p></div>
            <div class="esa-table" role="table" aria-label="Correos automáticos">
                <div class="esa-tr is-head" role="row"><span role="columnheader">Correo</span><span role="columnheader">Cuándo se manda</span><span role="columnheader">Desde</span><span role="columnheader">Para</span><span role="columnheader">Estado</span></div>
                ${this.TX_TEMPLATES.map(t => { const info = this.TX_INFO[t.type] || {}; const ed = this._edited[t.type]; return `
                <button type="button" class="esa-tr" role="row" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.showSection('tx:'+String(captured[0]));}, [t.type])}>
                    <b role="cell">${Utils.sanitizeHTML(t.label)}</b><span role="cell" class="esa-when">${Utils.sanitizeHTML(t.help || '')}</span>
                    <span role="cell">${Utils.sanitizeHTML(info.from || '')}</span><span role="cell">${Utils.sanitizeHTML(info.to || '')}</span>
                    <span role="cell" class="esa-state ${ed !== undefined ? 'is-edited' : ''}">${ed !== undefined ? `Editado${ed ? ' · ' + this._ago(ed) : ''}` : 'Por defecto'}</span>
                </button>`; }).join('')}
            </div>`);
    },

    // The bottom bar: what is unsaved in the open section and its buttons.
    renderBar() {
        const bar = document.getElementById('esa-bar');
        if (!bar) return;
        const id = this.section;
        if (id === 'all') { bar.hidden = true; return; }
        bar.hidden = false;
        if (id.startsWith('tx:')) {
            const meta = this.getCurrentTxTemplateMeta();
            const dirty = this._txDirty();
            bar.classList.toggle('is-dirty', dirty);
            SafeHTML.set(bar, `
                <span class="esa-bar-status" role="status">${dirty ? `Cambios sin guardar en «${Utils.sanitizeHTML(meta?.label || '')}»` : 'Sin cambios'}</span>
                <button type="button" class="esa-btn" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.resetTxTemplate();}, [])}>Restaurar por defecto</button>
                <button type="button" class="esa-btn" ${dirty ? '' : 'disabled'} ${UIEvents.attr("click", function(event,captured){EmailSettingsView.discardTx();}, [])}>Descartar</button>
                <button type="button" class="esa-btn is-primary" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.saveTxTemplate();}, [])}><i class="fas fa-save" aria-hidden="true"></i> Guardar</button>`);
            return;
        }
        const form = document.getElementById('email-settings-form');
        const n = form ? [...form.elements].filter(el => el.name && (el.type === 'checkbox' ? el.checked !== el.defaultChecked : 'defaultValue' in el && el.type !== 'hidden' && el.value !== el.defaultValue)).length : 0;
        if (form) [...form.elements].forEach(el => el.classList?.toggle('is-changed', !!el.name && (el.type === 'checkbox' ? el.checked !== el.defaultChecked : 'defaultValue' in el && el.value !== el.defaultValue)));
        bar.classList.toggle('is-dirty', n > 0);
        SafeHTML.set(bar, `
            <span class="esa-bar-status" role="status">${n ? `${n} ${n === 1 ? 'cambio' : 'cambios'} sin guardar` : 'Sin cambios'}</span>
            ${AuthManager.isAdmin() ? `<button type="button" class="esa-btn" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.openTestModal();}, [])}><i class="fas fa-paper-plane" aria-hidden="true"></i> Enviar correo de prueba</button>` : ''}
            <button type="button" class="esa-btn" ${n ? '' : 'disabled'} ${UIEvents.attr("click", function(event,captured){EmailSettingsView.discardForm();}, [])}>Descartar</button>
            <button type="submit" form="email-settings-form" class="esa-btn is-primary"><i class="fas fa-save" aria-hidden="true"></i> Guardar cambios</button>`);
    },

    discardForm() {
        const form = document.getElementById('email-settings-form');
        if (form) form.reset();
        this.renderBar();
    },

    GROUPS: [
        { key: 'admisiones', label: 'Admisiones', icon: 'fa-bullhorn',
          sends: 'Campañas a contactos, invitación a visitar, enlace de inscripción, confirmación de solicitud y cita de entrevista.' },
        { key: 'administracion', label: 'Administración', icon: 'fa-briefcase',
          sends: 'Aviso de pago, alta de alumno con usuario y contraseña, recuperar contraseña y alta de profesor para la asesoría.' }
    ],

    _field(name, label, type, value, { placeholder = '', hint = '', lock = '', required = false } = {}) {
        return `<label class="esa-field"><span>${label}</span>
            <input type="${type}" name="${name}" class="esa-input" ${lock} ${required ? 'required' : ''} ${type === 'password' ? 'autocomplete="new-password"' : ''} value="${Utils.sanitizeHTML(value || '')}" placeholder="${Utils.sanitizeHTML(placeholder)}">
            ${hint ? `<small>${hint}</small>` : ''}</label>`;
    },

    renderGroupCard(group) {
        const g = this.config.groups?.[group.key] || {};
        const lock = AuthManager.isAdmin() ? '' : 'disabled';
        return `
            <section class="esa-card" data-es-section="acc-${group.key}" hidden>
                <div class="esa-card-head"><h2>Cuenta de ${group.label}</h2><p>${group.sends}</p>
                    <span class="esa-pill ${g.smtpUser ? 'is-ok' : 'is-warn'}">${g.smtpUser ? '✓ Cuenta propia' : 'Usa la cuenta general'}</span></div>
                <div class="esa-grid">
                    ${this._field(`group-${group.key}-smtpUser`, 'Cuenta de envío', 'email', g.smtpUser, { placeholder: 'Vacío: se envía con la cuenta general', hint: 'Un buzón real del mismo servidor de correo (no un alias).', lock })}
                    ${this._field(`group-${group.key}-smtpPass`, 'Contraseña', 'password', '', { placeholder: g.passSet ? '•••••••• (sin cambios)' : 'Contraseña del buzón', hint: 'Déjala en blanco para no cambiarla.', lock })}
                    ${this._field(`group-${group.key}-displayName`, 'Nombre visible', 'text', g.displayName, { placeholder: `${group.label} ${SchoolService.shortName()} - ${SchoolService.name()}`, hint: 'Vacío: se usa el que ves de ejemplo.', lock })}
                    ${this._field(`group-${group.key}-replyTo`, 'Respuestas a', 'email', g.replyTo, { placeholder: g.smtpUser || 'La cuenta de envío', hint: 'Vacío: las respuestas llegan a la propia cuenta de envío.', lock })}
                </div>
            </section>`;
    },

    groupsPayload(form) {
        const value = name => (form.elements[name]?.value || '').trim();
        return Object.fromEntries(this.GROUPS.map(({ key }) => [key, AuthManager.isAdmin() ? {
            smtpUser: value(`group-${key}-smtpUser`), smtpPass: value(`group-${key}-smtpPass`) || undefined,
            displayName: value(`group-${key}-displayName`), replyTo: value(`group-${key}-replyTo`)
        } : { smtpUser: this.config.groups?.[key]?.smtpUser || '', displayName: this.config.groups?.[key]?.displayName || '', replyTo: this.config.groups?.[key]?.replyTo || '' }]));
    },

    async loadConfig() {
        const token = AuthManager.getCsrfToken();
        const response = await fetch('/api/settings/email-config', {
            headers: { 'X-SICAF-CSRF': token }
        });
        const data = await response.json();
        if (data.success) {
            this.config = data.config;
        } else {
            throw new Error(data.error || 'Failed to fetch settings');
        }
    },

    renderForm() {
        const container = document.getElementById('email-settings-form-container');
        if (!container || !this.config) return;
        // Server, account and password are admin-only (server/security/email-config.js).
        const admin = AuthManager.isAdmin();
        const serverLock = admin ? '' : 'readonly title="Solo administración puede cambiar el servidor de correo"';
        const c = this.config;
        SafeHTML.set(container, `
            <form id="email-settings-form" ${UIEvents.attr("submit", function(event,captured){EmailSettingsView.handleSubmit(event);}, [])}
                ${UIEvents.attr("input", function(event,captured){EmailSettingsView.renderBar();}, [])} ${UIEvents.attr("change", function(event,captured){EmailSettingsView.renderBar();}, [])}>
                <section class="esa-card" data-es-section="server" hidden>
                    <div class="esa-card-head"><h2>Servidor de salida</h2><p>El servidor con el que SICAF manda todos los correos.</p>
                        <span class="esa-pill ${c.smtpPassSet ? 'is-ok' : 'is-warn'}">${c.smtpPassSet ? '✓ Contraseña guardada' : 'Falta la contraseña'}</span></div>
                    <div class="esa-grid is-server">
                        ${this._field('smtpHost', 'Servidor (host)', 'text', c.smtpHost, { lock: serverLock, required: true })}
                        ${this._field('smtpPort', 'Puerto', 'number', c.smtpPort, { lock: serverLock, required: true })}
                        <label class="esa-check"><input type="checkbox" name="smtpSecure" ${c.smtpSecure ? 'checked' : ''} ${admin ? '' : 'disabled'}> Conexión segura (SSL)</label>
                        ${this._field('smtpUser', 'Cuenta general de envío', 'email', c.smtpUser, { lock: serverLock, required: true, hint: 'Se usa cuando un grupo no tiene cuenta propia.' })}
                        ${this._field('smtpPass', 'Contraseña', 'password', '', { lock: admin ? '' : 'disabled', placeholder: c.smtpPassSet ? '•••••••• (sin cambios)' : 'Sin contraseña configurada', hint: 'Por seguridad no se muestra la guardada. En blanco: no se cambia.' })}
                    </div>
                </section>
                ${this.GROUPS.map(group => this.renderGroupCard(group)).join('')}
                <section class="esa-card" data-es-section="dest" hidden>
                    <div class="esa-card-head"><h2>Destinatarios de avisos</h2><p>Adónde llegan los avisos internos que manda SICAF.</p></div>
                    <div class="esa-grid">
                        ${this._field('advisoryRecipient', 'Altas de profesores (asesoría)', 'email', c.advisoryRecipient, { required: true, hint: 'La gestoría que tramita las altas.' })}
                        ${this._field('interviewRecipient', 'Entrevistas (admisiones)', 'email', c.interviewRecipient, { required: true, hint: 'Aviso de cada solicitud que necesita entrevista.' })}
                        ${this._field('paymentDocsRecipient', 'Documentación de pago', 'email', c.paymentDocsRecipient, { required: true, hint: 'Aviso cuando un alumno sube justificantes o DNI.' })}
                        ${this._field('replyToAddress', 'Responder a (Reply-To)', 'email', c.replyToAddress, { required: true, hint: 'Adónde responde quien recibe un aviso.' })}
                    </div>
                </section>
            </form>`);
        document.querySelectorAll('[data-es-section]').forEach(el => { el.hidden = el.dataset.esSection !== this.section; });
        this.renderMenu();
        this.renderBar();
    },

    async handleSubmit(e) {
        e.preventDefault();
        if (!AuthManager.requireModuleManage("email-settings",["admin"])) return;
        const form = e.target;
        const formData = new FormData(form);
        const newPass = formData.get('smtpPass');
        const data = {
            smtpHost: formData.get('smtpHost'),
            smtpPort: parseInt(formData.get('smtpPort'), 10),
            smtpSecure: form.elements.smtpSecure.checked,
            smtpUser: formData.get('smtpUser'),
            // Vacío = "no tocar la contraseña guardada" (el servidor conserva la actual)
            smtpPass: newPass ? newPass : undefined,
            advisoryRecipient: formData.get('advisoryRecipient'),
            interviewRecipient: formData.get('interviewRecipient'),
            replyToAddress: formData.get('replyToAddress'),
            groups: this.groupsPayload(form),
            paymentDocsRecipient: formData.get('paymentDocsRecipient')
        };
        // Delegated managers change recipients only: send the server settings unchanged.
        if (!AuthManager.isAdmin()) {
            Object.assign(data, { smtpHost: this.config.smtpHost, smtpPort: this.config.smtpPort, smtpSecure: this.config.smtpSecure, smtpUser: this.config.smtpUser, smtpPass: undefined });
        }

        try {
            const token = AuthManager.getCsrfToken();
            const response = await fetch('/api/settings/email-config', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-SICAF-CSRF': token
                },
                body: JSON.stringify(data)
            });
            const res = await response.json();
            if (res.success) {
                Utils.showToast('Configuración guardada correctamente', 'success');
                // Reload configuration locally — nunca guardamos la contraseña real en el cliente,
                // solo si ha quedado alguna configurada (la que había, o la que se acaba de escribir).
                this.config = { ...data, smtpPassSet: !!(newPass || this.config.smtpPassSet) };
                delete this.config.smtpPass;
                this.renderForm();
            } else {
                throw new Error(res.error || 'Failed to save configuration');
            }
        } catch (error) {
            console.error('Error al guardar configuración:', error);
            Utils.showToast('Error al guardar la configuración: ' + error.message, 'danger');
        }
    },

    openTestModal() {
        const modalHtml = `
            <div id="test-email-modal" style="position: fixed; inset: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 10000; animation: fadeIn 0.15s ease-out;">
                <div style="background: white; width: 100%; max-width: 480px; border-radius: 16px; padding: 2rem; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04); animation: slideUp 0.2s ease-out;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
                        <h3 style="margin: 0; font-size: 1.25rem; font-weight: 700; color: #0f172a; display: flex; align-items: center; gap: 0.5rem;">
                            <i class="fas fa-paper-plane" style="color: #6366f1;"></i> Probar Configuración
                        </h3>
                        <button ${UIEvents.attr("click", function(event,captured){document.getElementById('test-email-modal').remove();}, [])} style="background: none; border: none; font-size: 1.15rem; color: #94a3b8; cursor: pointer;">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    
                    <p style="font-size: 0.9rem; color: #64748b; margin-top: 0; margin-bottom: 1.25rem;">
                        Introduce una dirección de correo para enviar un mensaje de prueba con la configuración guardada actual.
                    </p>
                    
                    <div style="margin-bottom: 1.5rem;">
                        <label style="display: block; font-size: 0.85rem; font-weight: 700; color: #475569; margin-bottom: 0.5rem;">Enviar a:</label>
                        <input type="email" id="test-recipient-email" required style="width: 100%; padding: 0.75rem; border-radius: 8px; border: 1px solid #cbd5e1; outline: none; font-size: 0.9rem;" placeholder="Correo electrónico">
                    </div>
                    
                    <div style="display: flex; justify-content: flex-end; gap: 0.75rem;">
                        <button ${UIEvents.attr("click", function(event,captured){document.getElementById('test-email-modal').remove();}, [])} class="btn btn-secondary" style="padding: 0.6rem 1.25rem; font-weight: 600; border-radius: 8px;">
                            Cancelar
                        </button>
                        <button id="test-email-send-btn" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.sendTestEmail();}, [])} class="btn btn-primary" style="padding: 0.6rem 1.5rem; font-weight: 600; border-radius: 8px; background: #6366f1; border-color: #6366f1;">
                            Enviar Prueba
                        </button>
                    </div>
                </div>
            </div>
        `;
        SafeHTML.insert(document.body, 'beforeend', modalHtml);
        
        // Add fade-in and slide-up animations if styles don't exist
        if (!document.getElementById('email-settings-animations')) {
            const style = document.createElement('style');
            style.id = 'email-settings-animations';
            SafeHTML.set(style, `
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
            `);
            document.head.appendChild(style);
        }
    },

    async sendTestEmail() {
        if(!AuthManager.requireModuleManage('email-settings',['admin']))return;
        const recipientInput = document.getElementById('test-recipient-email');
        const email = recipientInput ? recipientInput.value.trim() : '';
        if (!email) {
            Utils.showToast('Por favor, introduce una dirección de correo válida', 'warning');
            return;
        }

        const modal = document.getElementById('test-email-modal');
        const btn = document.getElementById('test-email-send-btn');
        const originalText = btn.innerHTML;
        
        btn.disabled = true;
        SafeHTML.set(btn, '<i class="fas fa-spinner fa-spin"></i> Enviando...');

        try {
            const token = AuthManager.getCsrfToken();
            const response = await fetch('/api/settings/email/test', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-SICAF-CSRF': token
                },
                body: JSON.stringify({ to: email })
            });
            const res = await response.json();
            if (res.success) {
                const sent = (res.results || []).map(r => `${r.group} (${r.account})`).join(', ');
                Utils.showToast(sent ? `Correos de prueba enviados: ${sent}` : 'Correo de prueba enviado con éxito', 'success');
                modal.remove();
            } else {
                throw new Error(res.error || 'Failed to send test email');
            }
        } catch (error) {
            console.error('Error al enviar correo de prueba:', error);
            Utils.showToast('Error al enviar: ' + error.message, 'danger');
            btn.disabled = false;
            SafeHTML.set(btn, originalText);
        }
    },

    // ========================================================
    // Correos automáticos: one e-mail at a time (this.TX_TEMPLATES), opened from the menu.
    // Visual/HTML editor (ids «tx-»), the sample preview beside it, the check of the variables
    // it cannot go without and «Enviarme una prueba de este correo».
    // ========================================================
    renderTemplatesPanel() {
        const panel = document.getElementById('es-panel-correos');
        if (!panel) return;
        SafeHTML.set(panel, `
            <div class="esa-card-head esa-tx-head">
                <div class="esa-tx-title"><h2 id="tx-template-title"></h2><div class="esa-chips" id="tx-template-help"></div></div>
                <button type="button" class="esa-btn" id="tx-test-btn" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.sendTxTest();}, [])}><i class="fas fa-paper-plane" aria-hidden="true"></i> Enviarme una prueba de este correo</button>
            </div>
            <div class="esa-tx-body">
                <div class="esa-tx-edit">
                    <label class="esa-field"><span>Asunto</span><input type="text" id="tx-template-subject" class="esa-input" placeholder="Asunto del correo" ${UIEvents.attr("input", function(event,captured){EmailSettingsView.onTxInput();}, [])}></label>
                    <div class="esa-editor">
                        <div class="esa-toolbar">
                            <button type="button" class="esa-tool" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.execTxCmd('bold');}, [])} title="Negrita" aria-label="Negrita"><i class="fas fa-bold" aria-hidden="true"></i></button>
                            <button type="button" class="esa-tool" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.execTxCmd('italic');}, [])} title="Cursiva" aria-label="Cursiva"><i class="fas fa-italic" aria-hidden="true"></i></button>
                            <button type="button" class="esa-tool" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.execTxCmd('underline');}, [])} title="Subrayado" aria-label="Subrayado"><i class="fas fa-underline" aria-hidden="true"></i></button>
                            <button type="button" class="esa-tool" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.insertTxLink();}, [])} title="Insertar enlace" aria-label="Insertar enlace"><i class="fas fa-link" aria-hidden="true"></i></button>
                            <span class="esa-sep" aria-hidden="true"></span>
                            <span class="esa-label">Insertar</span>
                            <span id="tx-var-buttons" class="esa-vars"></span>
                            <span class="esa-spacer"></span>
                            <div class="esa-seg" role="group" aria-label="Modo del editor">
                                <button type="button" id="tx-mode-btn-wysiwyg" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.setTxEditorMode('wysiwyg');}, [])}>Normal</button>
                                <button type="button" id="tx-mode-btn-html" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.setTxEditorMode('html');}, [])}>HTML</button>
                            </div>
                        </div>
                        <div id="tx-wysiwyg-container"><div id="tx-template-wysiwyg" class="esa-wysiwyg" contenteditable="true"></div></div>
                        <textarea id="tx-template-html-code" class="esa-code" placeholder="Cuerpo del correo en HTML" style="display: none;"></textarea>
                    </div>
                    <div class="esa-warn" id="tx-vars-warning" role="alert" hidden></div>
                    <p class="esa-muted">Las variables entre llaves (como {{nombre}}) se cambian por el dato real al enviar el correo.</p>
                </div>
                <div class="esa-tx-preview">
                    <div class="esa-preview-head"><span class="esa-label">Vista previa con datos de ejemplo</span>
                        <div class="esa-seg" role="group" aria-label="Tamaño de la vista previa">
                            <button type="button" id="tx-dev-desktop" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.setDevice('desktop');}, [])}>Escritorio</button>
                            <button type="button" id="tx-dev-mobile" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.setDevice('mobile');}, [])}>Móvil</button>
                        </div>
                    </div>
                    <div class="esa-preview" id="tx-preview-box"></div>
                </div>
            </div>`);
        const editor = document.getElementById('tx-template-wysiwyg');
        const code = document.getElementById('tx-template-html-code');
        editor.addEventListener('input', () => { code.value = editor.innerHTML; this.onTxInput(); });
        code.addEventListener('input', () => this.onTxInput());
        this.txEditorMode = 'wysiwyg';
        this._paintModes();
    },

    _paintModes() {
        const on = (id, active) => { const b = document.getElementById(id); if (b) { b.classList.toggle('is-on', active); b.setAttribute('aria-pressed', String(active)); } };
        on('tx-mode-btn-wysiwyg', this.txEditorMode !== 'html'); on('tx-mode-btn-html', this.txEditorMode === 'html');
        on('tx-dev-desktop', this._device !== 'mobile'); on('tx-dev-mobile', this._device === 'mobile');
    },

    _txCurrent() {
        const subject = document.getElementById('tx-template-subject')?.value.trim() || '';
        const body = this.txEditorMode === 'html' ? (document.getElementById('tx-template-html-code')?.value.trim() || '') : (document.getElementById('tx-template-wysiwyg')?.innerHTML || '');
        return { subject, body };
    },
    _txDirty() {
        if (!this._txLoaded || this._txLoadedType !== this._txType) return false;
        const now = this._txCurrent();
        return now.subject !== this._txLoaded.subject.trim() || now.body.trim() !== this._txLoaded.body.trim();
    },
    _missingVars() {
        const info = this.TX_INFO[this._txType];
        if (!info || this._txLoadedType !== this._txType) return [];
        const { subject, body } = this._txCurrent();
        return info.required.filter(v => !(subject + body).includes(`{{${v}}}`));
    },

    // Typing: the preview, the variables check, the menu mark and the bar follow.
    onTxInput() {
        clearTimeout(this._txPreviewTimer);
        this._txPreviewTimer = setTimeout(() => this.renderTxPreview(), 250);
        const missing = this._missingVars();
        const warn = document.getElementById('tx-vars-warning');
        if (warn) {
            warn.hidden = !missing.length;
            warn.textContent = missing.length ? `Revisa: este correo debe llevar ${missing.map(v => this.VAR_LABELS[v] || v).join(' y ')} (${missing.map(v => '{{' + v + '}}').join(', ')}) y ahora no ${missing.length === 1 ? 'lo lleva' : 'los lleva'}.` : '';
        }
        this.renderMenu();
        this.renderBar();
    },

    renderTxPreview() {
        const box = document.getElementById('tx-preview-box');
        if (!box || this._txLoadedType !== this._txType) return;
        const vars = { ...this.SAMPLE, escuela: SchoolService.name(), escuelaSiglas: SchoolService.shortName(), escuelaWeb: SchoolService.get('website') || '', escuelaEmail: SchoolService.get('contactEmail') || '',
            escuelaTelefono: SchoolService.get('phone') || '', escuelaDireccion: SchoolService.get('address') || '', escuelaRazonSocial: SchoolService.get('legalName') || '' };
        const { body } = this._txCurrent();
        const html = body.replace(/\{\{([a-zA-Z][a-zA-Z0-9]*)\}\}/g, (match, key) => Object.hasOwn(vars, key) ? Utils.sanitizeHTML(String(vars[key])) : match);
        box.classList.toggle('is-mobile', this._device === 'mobile');
        try {
            const frame = EmailHtml.frame(html, 'Vista previa del correo con datos de ejemplo');
            box.replaceChildren(frame);
        } catch (error) {
            box.textContent = error.message;
        }
    },

    setDevice(device) {
        this._device = device === 'mobile' ? 'mobile' : 'desktop';
        this._paintModes();
        this.renderTxPreview();
    },

    discardTx() {
        if (!this._txLoaded) return;
        document.getElementById('tx-template-subject').value = this._txLoaded.subject;
        EmailHtml.set(document.getElementById('tx-template-wysiwyg'), this._txLoaded.body, document.getElementById('tx-template-html-code'));
        this.onTxInput();
    },

    async sendTxTest() {
        const meta = this.getCurrentTxTemplateMeta();
        if (!meta || this._txLoadedType !== meta.type || this._txTesting) return;
        const { subject, body } = this._txCurrent();
        const button = document.getElementById('tx-test-btn');
        this._txTesting = true; if (button) button.disabled = true;
        try {
            const response = await fetch(`/api/settings/email-templates/${encodeURIComponent(meta.type)}/test`, {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': AuthManager.getCsrfToken() }, body: JSON.stringify({ subject, body }) });
            const res = await response.json().catch(() => null);
            if (!response.ok || !res?.success) throw new Error(res?.error || 'No se pudo enviar la prueba.');
            Utils.showToast(`Prueba enviada a ${res.to} con datos de ejemplo.`, 'success');
        } catch (error) {
            Utils.showToast(error.message, 'error');
        } finally {
            this._txTesting = false; if (button) button.disabled = false;
        }
    },

    setTxEditorMode(mode) {
        if (this.txEditorMode === mode) return;
        const wysiwygContainer = document.getElementById('tx-wysiwyg-container');
        const wysiwygEditor = document.getElementById('tx-template-wysiwyg');
        const htmlEditor = document.getElementById('tx-template-html-code');
        if (mode === 'wysiwyg') {
            try { EmailHtml.set(wysiwygEditor, htmlEditor.value, htmlEditor); }
            catch (error) { Utils.showToast(error.message, 'error'); return; }
            wysiwygContainer.style.display = 'block';
            htmlEditor.style.display = 'none';
        } else {
            htmlEditor.value = wysiwygEditor.innerHTML;
            wysiwygContainer.style.display = 'none';
            htmlEditor.style.display = 'block';
        }
        this.txEditorMode = mode;
        this._paintModes();
    },

    execTxCmd(command, value = null) {
        document.execCommand(command, false, value);
        const wysiwygEditor = document.getElementById('tx-template-wysiwyg');
        const htmlEditor = document.getElementById('tx-template-html-code');
        if (wysiwygEditor && htmlEditor) htmlEditor.value = wysiwygEditor.innerHTML;
        this.onTxInput();
    },

    insertTxTag(tag) {
        const wysiwygEditor = document.getElementById('tx-template-wysiwyg');
        if (!wysiwygEditor) return;
        wysiwygEditor.focus();
        const selection = window.getSelection();
        if (selection.getRangeAt && selection.rangeCount && wysiwygEditor.contains(selection.anchorNode)) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(document.createTextNode(tag));
        } else {
            wysiwygEditor.appendChild(document.createTextNode(tag));
        }
        const htmlEditor = document.getElementById('tx-template-html-code');
        if (htmlEditor) htmlEditor.value = wysiwygEditor.innerHTML;
        this.onTxInput();
    },

    insertTxLink() {
        const wysiwygEditor = document.getElementById('tx-template-wysiwyg');
        if (!wysiwygEditor) return;
        wysiwygEditor.focus();

        const selection = window.getSelection();
        let defaultUrl = 'https://';
        let anchorNode = null;
        if (selection.rangeCount > 0) {
            let node = selection.anchorNode;
            while (node && node !== wysiwygEditor) {
                if (node.nodeName === 'A') {
                    anchorNode = node;
                    defaultUrl = node.getAttribute('href');
                    break;
                }
                node = node.parentNode;
            }
        }

        SafeHTML.fire({
            title: 'Insertar / Editar Enlace',
            input: 'text',
            inputLabel: 'Dirección URL o variable (p.ej. {{enlace}})',
            inputValue: defaultUrl,
            placeholder: 'https://ejemplo.com o {{enlace}}',
            showCancelButton: true,
            confirmButtonColor: '#6366f1',
            confirmButtonText: 'Aplicar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => { if (!value) return 'Debes introducir una URL o variable válida'; }
        }).then((result) => {
            if (!result.isConfirmed) return;
            const url = result.value;
            if (!EmailHtml.validLink(url)) return;
            if (anchorNode) {
                anchorNode.setAttribute('href', url);
            } else {
                document.execCommand('createLink', false, url);
            }
            const htmlEditor = document.getElementById('tx-template-html-code');
            if (htmlEditor) htmlEditor.value = wysiwygEditor.innerHTML;
            this.onTxInput();
        });
    },

    getCurrentTxTemplateMeta() {
        return this.TX_TEMPLATES.find(t => t.type === this._txType);
    },

    renderTxVarButtons(meta) {
        const container = document.getElementById('tx-var-buttons');
        if (!container) return;
        // The school's data (Ajustes → Datos del centro) is available in every template.
        const schoolVars = ['escuela', 'escuelaSiglas', 'escuelaWeb', 'escuelaEmail', 'escuelaTelefono', 'escuelaDireccion', 'escuelaRazonSocial'];
        SafeHTML.set(container, [...meta.vars, ...schoolVars].map(v =>
            `<button type="button" class="esa-var" ${UIEvents.attr("click", function(event,captured){EmailSettingsView.insertTxTag("{{"+String(captured[0])+"}}");}, [v])}>{{${v}}}</button>`
        ).join(''));
    },

    async loadTxTemplate(type) {
        const request = this._txLoadRequest = (this._txLoadRequest || 0) + 1;
        this._txLoadedType = null;
        const meta = this.TX_TEMPLATES.find(t => t.type === type);
        if (!meta) return;
        this._txType = type;
        this._txLoaded = null;

        const subjectInput = document.getElementById('tx-template-subject');
        const wysiwygEditor = document.getElementById('tx-template-wysiwyg');
        const htmlEditor = document.getElementById('tx-template-html-code');
        if (!subjectInput || !wysiwygEditor || !htmlEditor) return;

        const info = this.TX_INFO[type] || {};
        document.getElementById('tx-template-title').textContent = meta.label;
        const chips = edited => [`Cuándo: ${meta.help || ''}`, info.from && `Desde: ${info.from}`, info.to && `Para: ${info.to}`].filter(Boolean)
            .map(text => `<span class="esa-chip">${Utils.sanitizeHTML(text)}</span>`).join('') + (edited !== undefined ? `<span class="esa-chip is-edited">Editado${edited ? ' · ' + this._ago(edited) : ''}</span>` : '<span class="esa-chip">Por defecto</span>');
        SafeHTML.set(document.getElementById('tx-template-help'), chips(this._edited[type]));
        this.renderTxVarButtons(meta);

        subjectInput.disabled = true;
        wysiwygEditor.contentEditable = false;
        htmlEditor.disabled = true;
        subjectInput.value = 'Cargando...';
        SafeHTML.set(wysiwygEditor, '<p style="color:#64748b;font-style:italic;">Cargando plantilla...</p>');

        try {
            const token = AuthManager.getCsrfToken();
            const response = await fetch(`/api/settings/email-templates/${type}`, {
                headers: { 'X-SICAF-CSRF': token }
            });
            const res = await response.json();
            if (request !== this._txLoadRequest || !subjectInput.isConnected) return;
            if (!response.ok || !res.success) throw new Error('No se pudo cargar la plantilla');

            const targetSubject = (res.success && res.template) ? res.template.subject : meta.defaultSubject;
            const targetBody = (res.success && res.template) ? res.template.body : meta.defaultBody;

            subjectInput.value = targetSubject;
            EmailHtml.set(wysiwygEditor, targetBody, htmlEditor);
            this._txLoadedType = type;
            if (res.adjusted) Utils.showToast('Plantilla normalizada para mostrarla con seguridad. El original se conserva hasta que guardes.', 'info');

            this.txEditorMode = 'wysiwyg';
            document.getElementById('tx-wysiwyg-container').style.display = 'block';
            htmlEditor.style.display = 'none';
            this._paintModes();
            this._txLoaded = { subject: subjectInput.value, body: wysiwygEditor.innerHTML };
            if (res.updatedAt !== undefined && this._edited[type] === undefined && res.template) this._edited[type] = res.updatedAt;
        } catch (error) {
            if (request !== this._txLoadRequest || !subjectInput.isConnected) return;
            console.error('Error loading transactional template:', error);
            Utils.showToast('Error al cargar la plantilla desde el servidor', 'error');
            subjectInput.value = '';
            wysiwygEditor.textContent = '';
            htmlEditor.value = '';
        } finally {
            if (request === this._txLoadRequest && subjectInput.isConnected) {
                subjectInput.disabled = false;
                wysiwygEditor.contentEditable = true;
                htmlEditor.disabled = false;
                this.onTxInput();
                this.renderTxPreview();
            }
        }
    },

    // Vuelve al HTML/asunto por defecto tal cual llevaba el correo antes de
    // esta pantalla (this.TX_TEMPLATES[].default*) — no borra la plantilla
    // guardada en el servidor hasta que se pulse también "Guardar Plantilla".
    resetTxTemplate() {
        const meta = this.getCurrentTxTemplateMeta();
        if (!meta) return;
        document.getElementById('tx-template-subject').value = meta.defaultSubject;
        EmailHtml.set(document.getElementById('tx-template-wysiwyg'), meta.defaultBody, document.getElementById('tx-template-html-code'));
        this.onTxInput();
        Utils.showToast('Restaurado el contenido por defecto: pulsa «Guardar» para confirmarlo.', 'info');
    },

    async saveTxTemplate() {
        if (!AuthManager.requireModuleManage("email-templates",["admin"])) return;
        const meta = this.getCurrentTxTemplateMeta();
        const subjectInput = document.getElementById('tx-template-subject');
        const wysiwygEditor = document.getElementById('tx-template-wysiwyg');
        const htmlEditor = document.getElementById('tx-template-html-code');
        if (!meta || !subjectInput || !wysiwygEditor || !htmlEditor) return;
        if (this._txSaving) return;
        if (this._txLoadedType !== meta.type) { Utils.showToast('Espera a que se cargue la plantilla o vuelve a seleccionarla.', 'warning'); return; }

        const subject = subjectInput.value.trim();
        const body = (this.txEditorMode === 'wysiwyg') ? wysiwygEditor.innerHTML : htmlEditor.value.trim();

        if (!subject || !body) {
            Utils.showToast('El asunto y el contenido son obligatorios.', 'warning');
            return;
        }

        this._txSaving = true;
        try {
            const token = AuthManager.getCsrfToken();
            const response = await fetch('/api/settings/email-templates', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': token },
                body: JSON.stringify({ templateType: meta.type, subject, body })
            });
            const res = await response.json();
            if (response.ok && res.success) {
                if (subjectInput.isConnected && this.getCurrentTxTemplateMeta()?.type === meta.type && (this.txEditorMode === 'wysiwyg' ? wysiwygEditor.innerHTML : htmlEditor.value.trim()) === body) EmailHtml.set(wysiwygEditor, res.template.body, htmlEditor);
                Utils.showToast(res.adjusted ? 'Plantilla guardada. Se ha normalizado el HTML; revisa la vista previa.' : 'Plantilla guardada con éxito', 'success');
                if (this._txType === meta.type) this._txLoaded = this._txCurrent();
                this._edited[meta.type] = new Date().toISOString();
                SafeHTML.set(document.getElementById('tx-template-help'), document.getElementById('tx-template-help').innerHTML.replace(/<span class="esa-chip">Por defecto<\/span>|<span class="esa-chip is-edited">[^<]*<\/span>/, `<span class="esa-chip is-edited">Editado · ${this._ago(this._edited[meta.type])}</span>`));
                this.renderMenu();
                this.renderBar();
            } else {
                throw new Error(res.error || 'Fallo de guardado');
            }
        } catch (error) {
            console.error('Error saving transactional template:', error);
            Utils.showToast('Error al conectar con el servidor', 'error');
        } finally {
            this._txSaving = false;
        }
    }
};

window.EmailSettingsView = EmailSettingsView;
